import { bankServices } from "../../config/axios";
import {
    WITHDRAWEMONEY_APPROVEREJECT_SUCCESS,
    WITHDRAWEMONEY_APPROVEREJECT_FAILED,
    RESET_WITHDRAWEMONEY_APPROVEREJECT,
    LOADING_WITHDRAWEMONEY_APPROVEREJECT,
    WITHDRAWEMONEY_APPROVEREJECT_NETWORKERROR,
} from '../types/index';

const resetwithdrawEMoneyApproveReject = () => {
    return { type: RESET_WITHDRAWEMONEY_APPROVEREJECT };
};

const withdrawEMoneyApproveReject = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_WITHDRAWEMONEY_APPROVEREJECT });
    await bankServices
        .post("approvereject", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: WITHDRAWEMONEY_APPROVEREJECT_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: WITHDRAWEMONEY_APPROVEREJECT_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: WITHDRAWEMONEY_APPROVEREJECT_FAILED,
        payload: data
    };
}

export { resetwithdrawEMoneyApproveReject, withdrawEMoneyApproveReject }